import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { RolesList } from '@gtpl/shared-models/gtpl';
export class CreateUserDto {  
  @ApiProperty()
  @IsNotEmpty()  username: string;
  @ApiProperty()
  @IsNotEmpty()  password: string;
  @ApiProperty()
  @IsNotEmpty()  @IsEmail()  email: string;
  @ApiProperty({ enum: Object.values(RolesList) })
  @IsNotEmpty() role: RolesList;
  @ApiProperty()
  @IsNotEmpty() employeeId: number;
  @ApiProperty()
  @IsNotEmpty() status: boolean;
}
export class updateUserDto {  
  @ApiProperty()
  @IsNotEmpty()  id: Number;
  @ApiProperty()
  @IsNotEmpty()  username: string;
  @ApiProperty()
  @IsNotEmpty()  password: string;
  @ApiProperty()
  @IsNotEmpty()  @IsEmail()  email: string;
  @ApiProperty({ enum: Object.values(RolesList) })
  @IsNotEmpty() role: RolesList;
  @ApiProperty()
  @IsNotEmpty() employeeId: number;
  @ApiProperty()
  @IsNotEmpty() status: boolean;
}

export class UpdateUserDto {  
  @ApiProperty()
  @IsNotEmpty()  username: string;
  @ApiProperty() password: string;
  @ApiProperty()
  @IsNotEmpty()  @IsEmail()  email: string;
  @ApiProperty({ enum: Object.values(RolesList) })
  @IsNotEmpty() role: RolesList;
  @ApiProperty()
  @IsNotEmpty() employeeId: number;
  @ApiProperty()
  @IsNotEmpty() status: boolean;
}
export class UserDto { 
  @ApiProperty()
  @IsNotEmpty()  id: number;
  @ApiProperty()
  @IsNotEmpty()  username: string;
  @ApiProperty()
  @IsNotEmpty()  @IsEmail()  email: string;
  @ApiProperty()
  @IsNotEmpty() role: RolesList;
}
export class LoginUserDto { 
  @ApiProperty() 
  @IsNotEmpty()  readonly username: string;
  @ApiProperty()
  @IsNotEmpty()  readonly password: string;
}